import React from "react";
import { withI18n } from "react-i18next";
// @ts-ignore
import { CWBCheckbox } from "cwb-react";
import styled from "styled-components";
import { IAuditionInfoSheetDto } from "../../../interfaces/IAuditionInfoSheetDto";

const ConfirmDetailsSection = (props: {
  t: any;
  isReadOnly: boolean;
  handleChange?: (e: any, value: boolean) => void;
  auditionInfoSheet?: IAuditionInfoSheetDto;
}) => {
  const { t, isReadOnly, auditionInfoSheet, handleChange } = props;
  return (
    <section style={{ marginTop: "65px" }}>
      <Title>{t("Confirm")}</Title>
      <form>
        <div className="form-group row">
          <div className="col-12">
            <label className="col-form-label">
              {t("Are all of the details above correct? *")}
            </label>
            <StyledCheckbox
              key={`correct-details`}
              isChecked={auditionInfoSheet && auditionInfoSheet.isDetailCorrect}
              name="isDetailCorrect"
              disabled={isReadOnly}
              onClick={() =>
                handleChange(
                  "isDetailCorrect",
                  !auditionInfoSheet.isDetailCorrect
                )
              }
            />
            <label className="col-form-label">{t("Yes")}</label>
          </div>
        </div>
      </form>
    </section>
  );
};

export default withI18n()(ConfirmDetailsSection);

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
  margin-top: 20px;
`;

const StyledCheckbox = styled(CWBCheckbox)`
  display: inline;
  margin-left: 7px;
  margin-right: 7px;
  .icon-cwb-unchecked:before {
    font-size: ${(p) => p.theme["font-size"]};
  }
  .icon-cwb-checked:before {
    font-size: ${(p) => p.theme["font-size"]};
    color: ${(p) => p.theme.darkBlue};
  }
  &.child-cb {
    margin-left: 40px;
  }

  &.small-cb {
    display: flex;
    align-items: center;
    .icon-cwb-unchecked,
    .icon-cwb-unchecked:before,
    .icon-cwb-checked,
    .icon-cwb-checked:before {
      font-size: ${(p) => p.theme["sm-cb-font"]};
    }
  }
`;
